import { Check } from 'lucide-react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuItemIconSlot,
  DropdownMenuItemText,
  DropdownMenuTrigger,
  useTailwindBreakpoint,
} from '@eye-able/ui';
import { languages } from '@/i18n';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

const LanguageSelect = () => {
  const {
    t,
    i18n,
    i18n: { resolvedLanguage },
  } = useInlineTranslation();

  const isDesktop = useTailwindBreakpoint('xl');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type='button'
          variant='ghost'
          size={isDesktop ? 'default' : 'icon'}
          aria-label={t('language')}
        >
          <img
            alt=''
            aria-hidden
            src={getFlag(resolvedLanguage)}
            className='eye:border eye:border-grey-20'
            style={{ width: isDesktop ? '30px' : '20px' }}
          />
          <span className='eye:max-xl:sr-only'>{t('language')}</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className='eye:max-h-auto'
        align='end'
        side='bottom'
        aria-label={t('language')}
      >
        {Object.entries(languages).map(([code, option]) => (
          <DropdownMenuItem
            key={code}
            role='menuitemradio'
            aria-checked={code === resolvedLanguage}
            onClick={() => {
              void i18n.changeLanguage(code);
            }}
          >
            <DropdownMenuItemIconSlot>
              <LanguageSelectIcon
                code={code}
                className='eye:border eye:border-grey-20 eye:w-24'
              />
            </DropdownMenuItemIconSlot>
            <DropdownMenuItemText>{option.name}</DropdownMenuItemText>
            <span
              aria-hidden
              className='eye:flex eye:h-lh eye:w-16 eye:items-center eye:justify-end'
            >
              {code === resolvedLanguage ? <Check size={16} /> : null}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

function getFlag(code?: string) {
  if (!code) return '';
  return `https://assets.eye-able.com/dashboard-assets/flags/${code !== 'en' ? code : 'gb'}.svg`;
}

export const LanguageSelectIcon = ({
  code,
  className,
}: {
  code: string;
  className: string;
}) => <img className={className} src={getFlag(code)} alt='' aria-hidden />;

export default LanguageSelect;
